import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DocumentService } from '../services/document.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, DateAdapter, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { ActionsService } from '../services/actions.service';
import { Results } from '../ticket-system/ticket-system.component';
import { DeleteModal } from '../modals/modals.component';


@Component({
  selector: 'app-accept-protocol',
  templateUrl: './accept-protocol.component.html',
  styleUrls: ['./accept-protocol.component.css']
})
export class AcceptProtocolComponent implements OnInit {

  protocols: any;
  add: boolean;
  edit: boolean;
  delete: boolean;
  columns: any;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;
  token : string = localStorage.getItem('token');
  // created_at: any;
  // formattedDate: any;
  // number: any;
  // type: any;
  // reference_number: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private documentService: DocumentService,
    public dialog: MatDialog,
    private dateAdapter: DateAdapter<Date>, ) {
    this.getProtocols();
    dateAdapter.setLocale('en-GB');
  }

  ngOnInit() {
  }

  getProtocols() {
    this.documentService.getProtocols().subscribe(data => {
      console.log(data);
      if (data != null) {
        this.protocols = data;
      }
      this.displayedColumns = ['type','lng', 'number', 'created_at', 'request_number', 'actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Request>(this.protocols);
      this.selection = new SelectionModel<Request>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  acceptModalDialog(id): void{
    const dialogRef = this.dialog.open(AcceptModal, {
      width: '400px',
      data: { id:id }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getProtocols();
    });
  }

  declineModalDialog(id): void{
    const dialogRef = this.dialog.open(DeclineModal, {
      width: '400px',
      data: { id:id }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getProtocols();
    });
  }

  openResultsDialog(id): void {
    this.documentService.getResults(id).subscribe(resp => {
      console.log(resp);
      const dialogRef = this.dialog.open(ProtocolRes, {
        width: '1200px',
        height: '800px',
        data: { data: resp, result1: resp.result1, result2: resp.result2, result3: resp.result3, final_result: resp.final_result ,protocol_id:id}
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          var data = {
            id: id,
            technician_id: resp.technician_id,
            result1: result.result1,
            result2: result.result2,
            result3: result.result3,
            final_result: result.final_result
          }
          this.getProtocols();
        }
      });
    });

  }
}


@Component({
  selector: 'protocolRes',
  templateUrl: 'protocolRes.html',
})
export class ProtocolRes {

  results:any;
  columns: any;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any;
  selection: any;
  protocol_id:number;


  constructor(public dialogRef: MatDialogRef<Results>,private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA) public modalData: Results) {
    
    this.protocol_id = modalData.protocol_id;
    this.results = modalData.data;
    this.getResults();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  getResults() {
      this.displayedColumns = ['indicatorName', 'methodName', 'machineName', 'actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Request>(this.results);
      this.selection = new SelectionModel<Request>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

  }

  submit(data){
    var indicatorIds = [];
    this.results.forEach(element => {
      indicatorIds.push(element.id);
    });
    var form = {
      data:data,
      indicatorIds:indicatorIds
    }
    this.documentService.updateResults(form).subscribe(resp => {
      console.log(resp,this.protocol_id);
      if(resp){
        this.documentService.generateReqProtocol(resp, {protocol_id:this.protocol_id}).subscribe(resp2 => {
          this.getResults();
        });
      }
      
      this.dialogRef.close();
    })
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'acceptModal',
  templateUrl: 'acceptModal.html',
})
export class AcceptModal {
  protocol:number;
  constructor(
    public dialogRef: MatDialogRef<AcceptModal>,private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA) public data: DeleteModal) {
      console.log(data);
      this.protocol = data.id;
    }

    acceptProtocol(){
      var data = {
        userId:localStorage.getItem('user_id'),
        protocol:this.protocol,
      }
      this.documentService.acceptProtocol(data).subscribe(data => {
        this.closeModal();
      });
    }

    closeModal(): void {
      this.dialogRef.close();
    }

}

@Component({
  selector: 'declineModal',
  templateUrl: 'declineModal.html',
})
export class DeclineModal {
  protocol:number;
  constructor(
    public dialogRef: MatDialogRef<DeclineModal>,private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA) public data: DeleteModal) {
      this.protocol = data.id;
    }

    declineProtocol(){
      this.documentService.declineProtocol(this.protocol).subscribe(data => {
        this.closeModal();
      });
    }

    closeModal(): void {
      this.dialogRef.close();
    }

}